import BaseHttpClient from '../../base'
import { apis, getApiUrl } from '../api-config'

/**
 * Địa bàn
 */
class LocationAPI extends BaseHttpClient {}

export default new LocationAPI('v1/locations', 'Location', getApiUrl(apis.AuthAPI))
